export const ComingSoonPage = () => {
    return (<div>Coming Soon...</div>)
}
